import { Component, Input, TemplateRef } from '@angular/core';

@Component({
    selector: 'label-help',
    templateUrl: './label-help.component.html',
    standalone: false
})
export class LabelHelpComponent {
	@Input() tooltip: string | TemplateRef<any>;
}
